module.exports = __webpack_public_path__ + "img/Druid-tauren-f-70.3297853a.gif";